import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // onConnect: the form sends itself as soon as the page shows it.
  static values = { onConnect: Boolean };

  connect() {
    if (this.onConnectValue) this.element.requestSubmit();
  }

  submit() {
    // Petite temporisation pour permettre à l'utilisateur de voir le changement
    setTimeout(() => {
      this.element.requestSubmit();
    }, 100);
  }
}
